$(function() {
  $(document).on("click", ".js-apply-promo-btn", function() {
    const btn = $(this);
    const input = $(".js-promo-input");
    const errorDiv = $(".js-information__error-box.js-error_bottom");
    const promocode = input.val();
    const url = "/checkout/promocode";
    const type = "post";

    if (!promocode) {
      return;
    }

    btn.prop("disabled", true);
    input.prop("disabled", true);
    errorDiv.addClass("hidden");

    $.ajax({
      url,
      type,
      data: { promocode }
    })
      .then(response => {
        rewritePrices(response);
        $(".js-subtotal-row").slideDown();
      })
      .catch(response => {
        const {
          responseJSON: { message }
        } = response;
        errorDiv
          .html(message || "Promocode doesn't exist")
          .removeClass("hidden");
      })
      .always(() => {
        btn.prop("disabled", false);
        input.prop("disabled", false);
      });
  });
});

const rewritePrices = response => {
  const {
    total,
    subtotal,
    discount,
    discountValue,
    code = "code",
    description = ""
  } = response;
  $(".js-discount-value").val(discountValue);
  $(".js-subtotal-cost").html(subtotal);
  $(".js-subtotal-discount").html(discount);
  $(".js-total-cost").html(total);
  $(".js-promo-info").html(`Promotion ${code} Applied`);
  $(".js-promo-off").html(description);
};

export default {
  rewritePrices
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/promocode.js